import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const seoData = {
  "/": {
    metaTitle:
      "Glowtech Solutions | Best Business Solutions Provider in Hyderabad | Digital, HR & Tech Experts",
    metaDescription:
      "Grow your business with Glowtech Solutions — Hyderabad's best business solutions provider offering HR, staffing, digital marketing, IT services, and automation to drive your success.",
    focusKeyword: "Best Business Solutions Provider in Hyderabad",
    canonicalUrl: "https://www.glowtechsolutions.com/",
    robots: "index, follow",
    keywords: [
      "Top digital marketing services in Hyderabad",
      "SMS services",
      "WhatsApp API",
      "Indian staffing",
      "US staffing",
      "HR services",
      "Web development",
      "App development",
      "Promotional tools",
      "SEO",
      "PPC advertising",
      "Google ads",
      "Lead generation",
      "Social media marketing",
      "Email marketing",
    ],
  },
  "/about-glowtech-solutions": {
    metaTitle:
      "About Glowtech Solutions | Leading Business Solutions & Tech Experts in Hyderabad",
    metaDescription:
      "Discover the story behind Glowtech Solutions — Hyderabad's trusted provider of HR, staffing, digital marketing, IT services, and innovative business solutions driving growth and success.",
    focusKeyword: "About Glowtech Solutions",
    canonicalUrl: "https://www.glowtechsolutions.com/about-glowtech-solutions",
    robots: "index, follow",
    keywords: [
      "About Glowtech Solutions",
      "Business solutions company in Hyderabad",
      "Digital marketing experts",
      "HR and staffing company",
      "IT services provider Hyderabad",
      "Web development company",
      "App development experts",
      "Business automation services",
      "SEO and PPC services",
      "Social media marketing team",
      "Trusted business partner Hyderabad",
      "Our mission and vision",
      "Company leadership team",
      "Innovation in business solutions",
    ],
  },
  "/glowtech-services": {
    metaTitle:
      "Our Services | Digital Marketing, HR, IT, and Business Solutions | Glowtech Solutions",
    metaDescription:
      "Explore Glowtech Solutions' wide range of services including HR, staffing, digital marketing, web & app development, IT solutions, and business automation designed to help your company grow.",
    focusKeyword: "Glowtech Services",
    canonicalUrl: "https://www.glowtechsolutions.com/glowtech-services",
    robots: "index, follow",
    keywords: [
      "Glowtech Services",
      "Digital marketing services Hyderabad",
      "HR and staffing solutions",
      "IT services Hyderabad",
      "Web development services",
      "App development services",
      "Business automation tools",
      "SEO services",
      "PPC advertising",
      "Google Ads management",
      "Lead generation services",
      "Social media marketing",
      "Email marketing campaigns",
      "SMS marketing",
      "WhatsApp API integration",
    ],
  },
  "/glowtech-blogs": {
    metaTitle:
      "Glowtech Blogs | AI-Driven Insights on Digital Marketing, Tech & Staffing",
    metaDescription:
      "Explore expert blogs by Glowtech Solutions on AI-based digital marketing, HR automation, staffing, web/app development, and growth strategies for modern businesses.",
    focusKeyword: "Business Growth Blogs by Best Digital Solutions Company",
    canonicalUrl: "https://www.glowtechsolutions.com/glowtech-blogs",
    robots: "index, follow",
    keywords: [
      "AI business solutions",
      "Digital marketing trends",
      "HR automation insights",
      "Staffing industry updates",
      "Web development innovations",
      "App development strategies",
      "Business growth tips",
      "Tech blog Hyderabad",
      "Industry expert opinions",
      "Latest business technologies",
    ],
  },
  "/contact-glowtech-solutions": {
    metaTitle: "Contact Glowtech Solutions | AI-Driven Business Solutions",
    metaDescription:
      "Reach out to Glowtech Solutions for expert help in digital marketing, staffing, web development, and AI-powered business automation. Let's grow your business today.",
    focusKeyword: "Contact Best Business Solutions Provider in Hyderabad",
    canonicalUrl:
      "https://www.glowtechsolutions.com/contact-glowtech-solutions",
    robots: "index, follow",
    keywords: [
      "Contact Glowtech",
      "Business solutions contact",
      "Hyderabad tech company",
      "Get a free consultation",
      "Digital marketing inquiry",
      "HR solutions contact",
      "IT services support",
      "Web development quote",
      "App development help",
      "Business automation contact",
    ],
  },
  "/ai-based-web-development-services": {
    metaTitle:
      "AI-Based Web Development Services | Intelligent Websites & Digital Solutions | Glowtech Solutions",
    metaDescription:
      "Revolutionize your website with Glowtech's AI-based web development services. From AI-powered design to personalized user experiences, we create intelligent, future-ready websites.",
    focusKeyword: "AI-Based Web Development Services in Hyderabad",
    canonicalUrl:
      "https://www.glowtechsolutions.com/ai-based-web-development-services",
    robots: "index, follow",
    keywords: [
      "AI web development",
      "Smart website solutions",
      "Intelligent web design",
      "Machine learning websites",
      "Personalized user experiences",
      "Hyderabad web developers",
      "Future-ready websites",
      "Automated web solutions",
      "AI-powered CMS",
      "Responsive AI websites",
    ],
  },
  "/ai-integrated-staffing-solutions": {
    metaTitle:
      "AI-Integrated Staffing Solutions | Smart Recruitment Services | Glowtech Solutions",
    metaDescription:
      "Accelerate hiring with Glowtech's AI-powered staffing solutions. From resume screening to smart candidate matching, we deliver efficient, tech-driven recruitment.",
    focusKeyword: "AI-Integrated Staffing Solutions in Hyderabad",
    canonicalUrl:
      "https://www.glowtechsolutions.com/ai-integrated-staffing-solutions",
    robots: "index, follow",
    keywords: [
      "AI recruitment",
      "Smart staffing solutions",
      "Automated hiring process",
      "Candidate matching AI",
      "HR technology Hyderabad",
      "Talent acquisition AI",
      "Resume screening automation",
      "Intelligent staffing",
      "Recruitment optimization",
      "AI-powered hiring",
    ],
  },
  "/ai-based-app-development-services": {
    metaTitle:
      "Custom App Development Services | Android, iOS & AI-Powered Apps | Glowtech Solutions",
    metaDescription:
      "Build powerful mobile apps with Glowtech's AI-integrated app development services for Android, iOS, and cross-platform solutions tailored to your business needs.",
    focusKeyword: "AI-Based App Development Services in Hyderabad",
    canonicalUrl:
      "https://www.glowtechsolutions.com/ai-based-app-development-services",
    robots: "index, follow",
    keywords: [
      "AI app development",
      "Mobile app solutions",
      "Android app developers",
      "iOS app development",
      "Cross-platform apps",
      "Hyderabad app developers",
      "Intelligent mobile apps",
      "Machine learning apps",
      "Business mobile solutions",
      "Custom app programming",
    ],
  },
  "/sms-whatsapp-api-solutions": {
    metaTitle:
      "SMS & WhatsApp API Solutions | Smart Communication Tools | Glowtech Solutions",
    metaDescription:
      "Boost engagement with Glowtech's AI-powered SMS & WhatsApp API solutions for instant alerts, customer support, lead generation, and marketing automation.",
    focusKeyword: "AI-Driven SMS and WhatsApp API Solutions in Hyderabad",
    canonicalUrl:
      "https://www.glowtechsolutions.com/sms-whatsapp-api-solutions",
    robots: "index, follow",
    keywords: [
      "WhatsApp Business API",
      "Bulk SMS solutions",
      "AI messaging tools",
      "Chatbot integration",
      "Marketing automation",
      "Customer engagement tools",
      "Hyderabad SMS services",
      "WhatsApp marketing",
      "Notification systems",
      "Conversational AI",
    ],
  },
};

const PageMetadata = () => {
  const location = useLocation();
  const baseUrl = "https://www.glowtechsolutions.com";

  useEffect(() => {
    const meta = seoData[location.pathname] || {
      metaTitle: "Glowtech Solutions | AI-Driven Business Solutions",
      metaDescription: "Innovative business solutions powered by AI",
      canonicalUrl: `${baseUrl}${location.pathname}`,
      robots: "index, follow",
    };

    // 1. Document Title
    document.title = meta.metaTitle;

    // 2. Meta Description
    updateOrCreateMetaTag("name", "description", meta.metaDescription);

    // 3. Keywords (if available)
    if (meta.keywords) {
      updateOrCreateMetaTag("name", "keywords", meta.keywords.join(", "));
    }

    // 4. Robots Meta Tag
    updateOrCreateMetaTag("name", "robots", meta.robots);

    // 5. Canonical Link Tag
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute(
      "href",
      meta.canonicalUrl || `${baseUrl}${location.pathname}`
    );

    // 6. OpenGraph Tags
    updateOrCreateMetaTag("property", "og:title", meta.metaTitle);
    updateOrCreateMetaTag("property", "og:description", meta.metaDescription);
    updateOrCreateMetaTag(
      "property",
      "og:url",
      meta.canonicalUrl || `${baseUrl}${location.pathname}`
    );
  }, [location.pathname]);

  // Helper function to update or create meta tags
  const updateOrCreateMetaTag = (attrName, attrValue, content) => {
    let tag = document.querySelector(`meta[${attrName}="${attrValue}"]`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attrName, attrValue);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  return null;
};

export default PageMetadata;
